import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { MobileActionBar } from "@/components/site/MobileActionBar";
import { JoinDialog } from "@/components/site/JoinDialog";
import Home from "@/pages/Home";
import Memberships from "@/pages/Memberships";
import Locations from "@/pages/Locations";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CustomPage from "@/pages/CustomPage";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  const { content } = useSite();
  if (!content) {
    return <div className="flex min-h-screen items-center justify-center" data-testid="site-loading"><span className="eyebrow">Loading</span></div>;
  }
  return (
    <>
      <Navbar />
      <main className="pb-20 md:pb-0">{children}</main>
      <Footer />
      <MobileActionBar />
      <JoinDialog />
    </>
  );
}

function AdminGate() {
  const { user } = useAuth();
  const { content } = useSite();
  if (user === null || !content) return <div className="flex min-h-screen items-center justify-center"><span className="eyebrow">Loading</span></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return <Admin />;
}

const pub = (el) => <PublicLayout>{el}</PublicLayout>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <ScrollTop />
            <Routes>
              <Route path="/" element={pub(<Home />)} />
              <Route path="/memberships" element={pub(<Memberships />)} />
              <Route path="/locations" element={pub(<Locations />)} />
              <Route path="/gallery" element={pub(<Gallery />)} />
              <Route path="/about" element={pub(<About />)} />
              <Route path="/contact" element={pub(<Contact />)} />
              <Route path="/p/:slug" element={pub(<CustomPage />)} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminGate />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster theme="dark" position="top-center" richColors />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
